<!-- https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E6%93%94%E4%BF%9D%E5%93%81%E9%91%91%E5%83%B9%E8%88%87%E5%AF%A9%E6%9F%A5
     https://8es9hr.axshare.com/#g=1&p=%E6%94%BE%E6%AC%BE%E7%94%B3%E8%AB%8B_%E6%93%94%E4%BF%9D%E5%93%81%E8%A8%AD%E5%AE%9A%E8%88%87%E5%AF%A9%E6%9F%A5 -->
<!-- 放款申請_擔保品鑑價與審查
     放款申請_擔保品設定與審查 -->
<template>
	<div v-if="$route.meta.subListKeepAlive">
		<workbench
			ref="ref"
			api="coopLoanApplyCollateral"
			:query="query"
			:columns="columns"
			:toolbar="toolbar"
			@editData="editData"
			@addData="editData"
		>
			<el-button
				slot="button"
				class="ml10"
				type="primary"
				v-if="this.$route.query.type == 'valuation' && !btnHide"
				@click="submitResult"
			>送出擔保品鑑價審查</el-button>
			<el-button
				slot="button"
				class="ml10"
				type="primary"
				v-if="this.$route.query.type == 'setting' && !btnHide"
				@click="submitSetResult"
			>送出擔保品設定審查</el-button>
		</workbench>
	</div>
	<router-view v-else></router-view>
</template>
<script>
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";
export default {
	name: "loan_collateral",
	props: {
		workflow: {
			type: Array,
			default: function () {
				return [];
			},
		},
	},
	components: { Workbench },
	data() {
		return {
			btnHide: false,
			query: {
				coopLoanApplyId: this.$route.params.id,
			},
            titleLabel: "",
			toolbar: {},
			columns: [
				{
					prop: "name",
					label: "名稱",
				},
				{
					prop: "subjectMatter",
					label: "標的物",
				},
				{
					prop: "setOrder",
					label: "設定順位",
				},
				{
					prop: "ownerName",
					label: "所有權人",
				},
				{
					prop: "basicInfo",
					label: "基本資料（地號、建號、車號）",
				},
				{
					prop: "valuationAmount",
					label: "鑑價金額",
					addcomma: true,
				},
				{
					prop: "isValuation",
					label: "鑑價審查",
				},
				{
					prop: "rightValue",
					label: "權利價值",
					addcomma: true,
				},
				{
					prop: "updateTime",
					label: "最後修改",
				},
				{
					prop: "updateUserName",
					label: "最後修改人員",
				},
			],
		};
	},
	created() {
		this.checkType();
	},
	watch: {
		$route(to, from) {
			this.checkType();
		},
		workflow() {
			this.getWorkStatus();
		},
	},
	methods: {
		/**
		 * 依查詢類型決定對應的審查流程節點名稱（鑑價／設定）
		 */
		checkType() {
			this.titleLabel = this.$route.query.type == "valuation"
				? "擔保品鑑價與審查"
				: "擔保品設定與審查";
		},
		/**
		 * 進入擔保品編輯頁
		 * @param {Number|String} id - 擔保品 id，新增時為 "new"
		 */
		editData(id) {
			this.$router.push({
				name: "loan_application_collateral_edit",
				params: { subId: id },
				query: { type: this.$route.query.type },
			});
		},
		submitResult() {
			let resultId = this.$route.params.id;
			let url =
				API.coopLoanApplyCollateral +
				`?action=submit&coopLoanApplyId=${resultId}`;
			let dataPost = new FormData();
			const postCB = (json) => {
				this.showAjaxSuccessMsg();
				this.$parent.isFirst = true;
				this.$parent.getWorkflow();
			};
			this.mAxiosPost(url, dataPost, postCB);
		},
		submitSetResult() {
			let resultId = this.$route.params.id;
			let url =
				API.coopLoanApplyCollateral +
				`?action=submitCollateral&coopLoanApplyId=${resultId}`;
			let dataPost = new FormData();
			const postCB = (json) => {
				this.showAjaxSuccessMsg();
				this.$parent.isFirst = true;
				this.$parent.getWorkflow();
			};
			this.mAxiosPost(url, dataPost, postCB);
		},
		getWorkStatus() {
			this.btnHide = this.workflow.some((item) => item.label == this.titleLabel && item.status == 2);
		},
		go(name, query) {
			this.$router.push({ name: name, query: { type: query } });
		},
	},
};
</script>